/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { attachCompanyNameToUrl, hasUUIDInUrl } from '../../../../../../../app/shared/functions';
import { Logger, LogService } from '@epg/angular-base-lib';
import {
  TaskDataArray,
  TaskDataImage,
  TaskDatumType
} from '../../../../../../../models/task.model';
export interface ImageSlider {
  image: string;
  thumbImage: string;
  title: string;
  description: string;
}
@Component({
  selector: 'app-array-item',
  templateUrl: './array-item.component.html',
  styleUrls: ['./array-item.component.scss'],
  standalone: false
})
export class ArrayItemComponent implements OnInit {
  @Input() arrayItem: TaskDataArray = new TaskDataArray([]);

  TaskDatumType = TaskDatumType;
  images: ImageSlider[] = [];
  isImageArray = false;
  truncateLength = 30;

  private log: Logger;

  constructor(logService: LogService) {
    this.log = logService.getLogger(this);
  }

  ngOnInit(): void {
    if (this.arrayItem.value.length > 0) {
      if (
        this.arrayItem.value[0].type == TaskDatumType.IMAGE_JPEG ||
        this.arrayItem.value[0].type == TaskDatumType.IMAGE_PNG ||
        this.arrayItem.value[0].type == TaskDatumType.IMAGE_URL ||
        this.arrayItem.value[0].type == TaskDatumType.EXTENDED_IMAGE
      ) {
        this.isImageArray = true;
        for (let index = 0; index < this.arrayItem.value.length; index++) {
          const image =
            this.arrayItem.value[index].type == TaskDatumType.EXTENDED_IMAGE
              ? this.arrayItem.value[index].value.image
              : this.arrayItem.value[index];
          const description =
            this.arrayItem.value[index].type == TaskDatumType.EXTENDED_IMAGE
              ? this.arrayItem.value[index].value.description.value
              : '';
          this.images.push(this.extractImageData(image, description));
        }
      }
      // for record
      if (
        this.arrayItem.value[0].type == TaskDatumType.OBJECT &&
        (this.arrayItem.value[0].value.get('image')?.type == TaskDatumType.IMAGE_JPEG ||
          this.arrayItem.value[0].value.get('image')?.type == TaskDatumType.IMAGE_PNG ||
          this.arrayItem.value[0].value.get('image')?.type == TaskDatumType.IMAGE_URL)
      ) {
        this.isImageArray = true;
        for (let index = 0; index < this.arrayItem.value.length; index++) {
          const image =
            this.arrayItem.value[index].type == TaskDatumType.EXTENDED_IMAGE
              ? this.arrayItem.value[index].value.image
              : this.arrayItem.value[index].value.get('image');
          const description =
            this.arrayItem.value[index].type == TaskDatumType.EXTENDED_IMAGE
              ? this.arrayItem.value[index].value.description.value
              : '';
          this.images.push(this.extractImageData(image, description));
        }
      }
    }
  }

  extractImageData(image: TaskDataImage, description: string): ImageSlider {
    let imageUrl = '';
    switch (image.type) {
      case TaskDatumType.IMAGE_JPEG:
        imageUrl = `data:image/jpeg;base64,${image.value}`;
        break;
      case TaskDatumType.IMAGE_PNG:
        imageUrl = `data:image/png;base64,${image.value}`;
        break;
      case TaskDatumType.IMAGE_URL:
        let url = attachCompanyNameToUrl(image.value);
        const separator = url.includes('?') ? '&' : '?';
        if (hasUUIDInUrl(url)) {
          url = `${url}${separator}returnType=direct`;
        }
        imageUrl = url;
        break;
    }

    return {
      image: imageUrl,
      thumbImage: imageUrl,
      title: description,
      description: description
    };
  }

  truncate(text: string) {
    if (text.length > this.truncateLength) {
      return text.substring(0, this.truncateLength) + '...';
    }
    return text;
  }

  onImageClick(images: ImageSlider[]) {
    images.forEach((image) => {
      image.title = image.description;
    });
  }

  onLightBoxClose(images: ImageSlider[]) {
    images.forEach((image) => {
      image.title = this.truncate(image.description ? image.description : '');
    });
  }
}
